export class EventBus {
    private static _instance = new EventBus()

    private listeners: any = {}

    static get instance() {
        return EventBus._instance
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    on(event: string, listener: Function): EventBus {
        if (!(event in this.listeners)) {
            this.listeners[event] = []
        }

        this.listeners[event].push(listener)

        return this
    }

    emit(event: string, ...args: any[]): EventBus {
        if (event in this.listeners) {
            // eslint-disable-next-line @typescript-eslint/ban-types
            this.listeners[event].forEach((listener: Function) => {
                // eslint-disable-next-line prefer-spread
                listener.apply(null, args)
            })
        }

        return this
    }
}
